/** 3点リーダーを加える */
export const toEllipsis = (value, max) => {
  if (typeof value === 'string' && value.toString().length > max) {
    return `${value.toString().substring(0, max - 1)}…`
  }
  return value
}
